export const TUTORIAL_STORAGE_PREFIX = 'ace_tutorial_v3_';

const PREFIX = TUTORIAL_STORAGE_PREFIX;

/** Used when localStorage is unavailable or throws after initial success. */
const sessionMemory = new Map();

let lsAvailable = false;
try {
  const probe = `${PREFIX}__probe__`;
  localStorage.setItem(probe, '1');
  localStorage.removeItem(probe);
  lsAvailable = true;
} catch {
  lsAvailable = false;
}

function fullKey(key) {
  return PREFIX + key;
}

/** True when preferences survive reloads; false means session-only in this tab. */
export function tutorialStorageIsPersistent() {
  return lsAvailable;
}

export function tutorialGet(key) {
  const fk = fullKey(key);
  if (lsAvailable) {
    try {
      return localStorage.getItem(fk);
    } catch {
      lsAvailable = false;
    }
  }
  return sessionMemory.get(fk) || null;
}

export function tutorialSet(key, value = '1') {
  const fk = fullKey(key);
  if (lsAvailable) {
    try {
      localStorage.setItem(fk, value);
      return;
    } catch {
      lsAvailable = false;
    }
  }
  sessionMemory.set(fk, value);
}

export function tutorialRemove(key) {
  const fk = fullKey(key);
  sessionMemory.delete(fk);
  if (lsAvailable) {
    try {
      localStorage.removeItem(fk);
    } catch {
      lsAvailable = false;
    }
  }
}

export function tutorialClearPrefix() {
  sessionMemory.clear();
  if (!lsAvailable) return;
  try {
    const keys = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const k = localStorage.key(i);
      if (k && k.startsWith(PREFIX)) keys.push(k);
    }
    keys.forEach((k) => localStorage.removeItem(k));
  } catch {
    lsAvailable = false;
  }
}

function getUserSuffix() {
  try {
    const raw = localStorage.getItem('userData');
    if (!raw) return '';
    const d = JSON.parse(raw);
    const id = d && (d._id || d.id || d.username);
    return id ? `_${id}` : '';
  } catch {
    return '';
  }
}

const SUPPRESS_ALL_KEY = 'suppress_all';

export function tutorialSuppressAll() {
  tutorialSet(`${SUPPRESS_ALL_KEY}${getUserSuffix()}`);
}

export function isTutorialSuppressed() {
  return !!tutorialGet(`${SUPPRESS_ALL_KEY}${getUserSuffix()}`);
}
